import { Box } from '@mui/material';

export const DietManagement = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
